import { useReduxState } from 'hooks';
import { Form, Select } from 'components/common/form';

import type { Course } from 'shared-types';
import type { UpdateEvents } from './EventLog';

interface Props {
  courses: Course[];
  updateEvents: UpdateEvents;
}

const EventLogCourseFilter = ({ courses, updateEvents }: Props) => {
  const { messages } = useReduxState();

  const handleCourseChange = async (course) => {
    await updateEvents({ course });
  };

  if (!courses || !courses.length) return null;

  const options = [
    { title: messages.commonAllCourses, id: 'all' },
    ...courses
  ].map((course) => ({
    label: course.title,
    value: course.id
  }));

  const initialValues = { course: 'all' };

  return (
    <div className="courses">
      <Form initialValues={initialValues}>
        {({ formState }) => (
          <Select
            ariaLabel={messages.commonFilterByCourse}
            dropdownStyles={true}
            field="course"
            id="course"
            isSearchable={true}
            onChange={handleCourseChange}
            options={options}
          />
        )}
      </Form>

      <style jsx>{`
        .courses {
          display: block;
          max-width: 300px;
          width: 300px;
        }
      `}</style>
    </div>
  );
};

export default EventLogCourseFilter;
